import ArchivioAreeTematicheId from './ArchivioAreeTematicheId';

export default ArchivioAreeTematicheId;
